import React, { useState, useEffect, useMemo } from "react";

// components
import Pagination from "../../hooks/Pagination";
import VideoModal from "../video-modal/VideoModal";

// assets
import playButtonImg from "../../assets/images/play-button.png";
import downloadButtonImg from "../../assets/images/download.png";

import "./InvestmentsStyles.css";

let PageSize = 5;

const AssetGalleryGrid = () => {
  const prodKey = process.env.REACT_APP_PRODUCT_KEY;
  const prUrl = process.env.REACT_APP_PUBLICRATES_URL;
  const url = `${prUrl}${prodKey}_holdings.json`;

  // states
  const [fetchedData, setFetchedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [modal, setModal] = useState(false); // Controls the modal show/hide functionality with a simple boolean.
  const [itemSku, setItemSku] = useState("");
  const [videoType, setVideoType] = useState("");
  const [downloadUrl, setDownloadUrl] = useState("");
  const [hostedVideo, setHostedVideo] = useState("");
  const [hostedVideoDocPath, setHostedVideoDocPath] = useState("");
  const [thumnnailImg, setThumbnailImg] = useState("");

  async function fetchData() {
    const response = await fetch(url);
    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
      throw new Error(message);
    }
    const data = await response.json();
    // console.log(data);
    setFetchedData(data.product.holding);
    setCurrentPage(1);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const currentTableData = useMemo(() => {
    // console.log(fetchedData);
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return fetchedData.slice(firstPageIndex, lastPageIndex);
  }, [currentPage]);

  // This function is for the holding price. It takes off anything after the first two digits after the decimal.
  function toFixed(num, fixed) {
    var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
    return num.toString().match(re)[0];
  }

  // This function is for converting the date I'm ingesting from the API to the format the spec says (Month and year)
  function formatDate(dateString) {
    const date = new Date(dateString); // Converts the string to a Date object
    const options = { year: "numeric", month: "long" }; // Specify the format for month and year
    return date.toLocaleString("en-US", options);
  }

  // Check the width of the page
  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
  });

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);

  // this runs on the close button on the modal. We have to set modalFitem to ('') or else the video will keep playing when you close the modal.
  function renderClose() {
    setModal(false);
    setItemSku("");
    setDownloadUrl("");
    setHostedVideo("");
    setHostedVideoDocPath("");
    setThumbnailImg("");
  }

  // Functional Component for handling more than one asset and the corresponding color.
  const AssetDisplay = ({ assetTypes, assetColors }) => {
    // Step 1: Split the strings into arrays
    const assetTypeArray = assetTypes.split(",");
    const assetColorArray = assetColors.split(",");

    // Step 2: Map the asset types to their corresponding colors
    const assetsWithColors = assetTypeArray.map((type, index) => ({
      type,
      color: assetColorArray[index],
    }));

    return (
      <>
        {assetsWithColors.map((asset, index) => (
          <span key={index} style={{ color: asset.color }}>
            {asset.type}
            {index < assetsWithColors.length - 1 ? ", " : ""}{" "}
            {/* Add comma and space, except after the last item */}
          </span>
        ))}
      </>
    );
  };

  return (
    <section id="holdings-section">
      {screenSize.dynamicWidth < 1200 ? (
        <div>
          {currentTableData.map((i) => {
            return (
              <div
                style={{
                  borderBottom: "1px solid black",
                  padding: "30px 45px",
                }}
                className="mobile-holdings-card-wrapper"
              >
                <p style={{ margin: "0", fontWeight: "400", fontSize: "18px" }}>
                  {i.holding_name}
                </p>
                <AssetDisplay
                  assetTypes={i.holding_asset_types}
                  assetColors={i.holding_asset_type_colors}
                />
                <span
                  style={{
                    fontWeight: "400",
                    fontSize: "18px",
                  }}
                >
                  &nbsp;in{" "}
                  {i.holding_locations.length > 11
                    ? "Multiple States"
                    : i.holding_locations}
                </span>
                <div className="text-sm mt-3 mb-5">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span>Ownership Interest</span>
                    <span>{i.ownership_interest_percent.split(".")[0]}%</span>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span>Acquisitions Date</span>
                    <span>{formatDate(i.holding_acquisition_date)}</span>
                  </div>
                </div>
                {i.item_download_url ? (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "auto 1fr",
                      alignItems: "center",
                      gap: "10px",
                      paddingBottom: "5px",
                    }}
                  >
                    <img
                      src={downloadButtonImg}
                      style={{ width: "30px", display: "block" }}
                      alt="download button"
                      className="pointer"
                      onClick={() => {
                        setItemSku(i.item_sku);
                        setDownloadUrl(i.item_download_url);
                        setHostedVideo(i.item_hosted_video);
                        setHostedVideoDocPath(
                          i.item_hosted_video_document_path
                        );
                        // setThumbnailImg(imgURL);
                        setModal(true);
                      }}
                    />
                    <span
                      className="pointer"
                      onClick={() => {
                        setItemSku(i.item_sku);
                        setDownloadUrl(i.item_download_url);
                        setHostedVideo(i.item_hosted_video);
                        setHostedVideoDocPath(
                          i.item_hosted_video_document_path
                        );
                        // setThumbnailImg(imgURL);
                        setModal(true);
                      }}
                    >
                      Acquisition Highlight
                    </span>
                  </div>
                ) : null}
                {/* we need to check a few things - 1. is video hosted? if no, link out, if yes concat the doc patch  2. is video? - this will determine what icon to show.  */}
                {i.pr_item_download_url ? (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "auto 1fr",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <img
                      src={playButtonImg}
                      style={{ width: "30px", display: "block" }}
                      alt="video button"
                      className="pointer"
                      onClick={() => {
                        setItemSku(i.pr_item_sku);
                        setDownloadUrl(i.pr_item_download_url);
                        setHostedVideo(i.pr_item_hosted_video);
                        setHostedVideoDocPath(
                          i.pr_item_hosted_video_document_path
                        );
                        // setThumbnailImg(imgURL);
                        setModal(true);
                      }}
                    />
                    <span
                      className="pointer"
                      onClick={() => {
                        setItemSku(i.pr_item_sku);
                        setDownloadUrl(i.pr_item_download_url);
                        setHostedVideo(i.pr_item_hosted_video);
                        setHostedVideoDocPath(
                          i.pr_item_hosted_video_document_path
                        );
                        // setThumbnailImg(imgURL);
                        setModal(true);
                      }}
                    >
                      Video Tour
                    </span>
                  </div>
                ) : null}
              </div>
            );
          })}
          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={fetchedData.length}
            pageSize={PageSize}
            onPageChange={(page) => setCurrentPage(page)}
          />
          <VideoModal
            show={modal}
            close={renderClose}
            sku={itemSku}
            notHostedLink={downloadUrl}
            isHosted={hostedVideo}
            hostedPath={hostedVideoDocPath}
            thumbnailImg={thumnnailImg}
            isVideo={hostedVideo}
          />
        </div>
      ) : (
        <div className="main-padding holding-table-main-wrapper">
          <div className="main-margin">
            <table className="investments-table-header table-shadow-main fixed-table mb-9 mt-20">
              <tr>
                <th
                  className="investments-table-tableheader-c"
                  style={{ textAlign: "left" }}
                >
                  Asset
                </th>
                <th className="investments-table-tableheader-c">Location</th>
                <th className="investments-table-tableheader-c">Type</th>
                {/* <th className="investments-table-tableheader-c">
                  Approximate Contract Purchase Price<sup>6</sup>
                </th> */}
                <th className="investments-table-tableheader-c">
                  Ownership Interest<sup>7</sup>
                </th>
                <th className="investments-table-tableheader-c">
                  Acquisitions Date
                </th>
                <th className="investments-table-tableheader-c">Learn More</th>
              </tr>

              {currentTableData.map((i) => {
                return (
                  <tr className="investments-table-tr" key={i.holding_id}>
                    <td>{i.holding_name}</td>
                    <td style={{ textAlign: "center" }}>
                      {i.holding_locations.length > 11
                        ? "Multiple States"
                        : i.holding_locations}
                    </td>
                    <td className="text-center">{i.holding_asset_types}</td>
                    {/* <td>${toFixed(i.holding_price, 2)}</td> */}
                    {/* <td style={{ textAlign: "right" }}>
                      ${Number(i.holding_price).toLocaleString("en-US")}
                    </td> */}
                    <td className="text-center">
                      {i.ownership_interest_percent.split(".")[0]}%
                    </td>
                    <td className="text-center">
                      {formatDate(i.holding_acquisition_date)}
                    </td>
                    <td>
                      <div>
                        {/* we need to check a few things - 1. is video hosted? if no, link out, if yes concat the doc patch  2. is video? - this will determine what icon to show.  */}
                        {i.item_download_url ? (
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "auto 1fr",
                              alignItems: "center",
                              gap: "10px",
                              paddingBottom: "10px",
                            }}
                          >
                            <img
                              src={downloadButtonImg}
                              style={{ width: "20px", display: "block" }}
                              alt="download button"
                              className="pointer"
                              onClick={() => {
                                setItemSku(i.item_sku);
                                setDownloadUrl(i.item_download_url);
                                setHostedVideo(i.item_hosted_video);
                                setHostedVideoDocPath(
                                  i.item_hosted_video_document_path
                                );
                                // setThumbnailImg(imgURL);
                                setModal(true);
                              }}
                            />
                            <span
                              className="pointer"
                              onClick={() => {
                                setItemSku(i.item_sku);
                                setDownloadUrl(i.item_download_url);
                                setHostedVideo(i.item_hosted_video);
                                setHostedVideoDocPath(
                                  i.item_hosted_video_document_path
                                );
                                // setThumbnailImg(imgURL);
                                setModal(true);
                              }}
                            >
                              Acquisition Highlight
                            </span>
                          </div>
                        ) : null}
                        {/* we need to check a few things - 1. is video hosted? if no, link out, if yes concat the doc patch  2. is video? - this will determine what icon to show.  */}
                        {i.pr_item_download_url ? (
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "auto 1fr",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <img
                              src={playButtonImg}
                              style={{ width: "20px", display: "block" }}
                              alt="video button"
                              className="pointer"
                              onClick={() => {
                                setItemSku(i.pr_item_sku);
                                setDownloadUrl(i.pr_item_download_url);
                                setHostedVideo(i.pr_item_hosted_video);
                                setHostedVideoDocPath(
                                  i.pr_item_hosted_video_document_path
                                );
                                // setThumbnailImg(imgURL);
                                setModal(true);
                              }}
                            />
                            <span
                              className="pointer"
                              onClick={() => {
                                setItemSku(i.pr_item_sku);
                                setDownloadUrl(i.pr_item_download_url);
                                setHostedVideo(i.pr_item_hosted_video);
                                setHostedVideoDocPath(
                                  i.pr_item_hosted_video_document_path
                                );
                                // setThumbnailImg(imgURL);
                                setModal(true);
                              }}
                            >
                              Video Tour
                            </span>
                          </div>
                        ) : null}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </table>
            <Pagination
              className="pagination-bar"
              currentPage={currentPage}
              totalCount={fetchedData.length}
              pageSize={PageSize}
              onPageChange={(page) => setCurrentPage(page)}
            />
            <VideoModal
              show={modal}
              close={renderClose}
              sku={itemSku}
              notHostedLink={downloadUrl}
              isHosted={hostedVideo}
              hostedPath={hostedVideoDocPath}
              thumbnailImg={thumnnailImg}
              isVideo={hostedVideo}
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default AssetGalleryGrid;
